/**
 *
 * 字符串工具类
 *
 *
 * */

class ArrayUtil {

  static isEmpty(obj) {

    //为null 或者 undefined
    if(!obj){
      return false;
    }

    // 为 []
    if(obj == []){
      return false;
    }

    return true;
  }

  static isArray (o) { //是否数组
    return Object.prototype.toString.call(o).slice(8, -1) === 'Array'
  }

  // 获取复杂对象数组中，某个key的value集合
  static getValues(arr, key){
    let result = [];
    arr.forEach(function(obj,index){
      //code something
      if(!obj[key]){
        obj[key] = null;
        result.push('');
      }
      result.push(obj[key]);
    });
    return result;
  }

  // 获取奇数集合
  static getOdds(arr){
    return arr.filter((val,index)=>{
      if(index%2 === 0){
        return true;
      }
    })
  }


  // 获取偶数集合
  static getEvens(arr){
    return arr.filter((val,index)=>{
      if(index%2 === 0){
        return true;
      }
    })
  }
  // 对象数组删除指定元素
  static removeObj(arr,obj,key){

    let curIndex = -1;
    arr.forEach(function(item, index) {
      if (obj[key] == item[key]) {
        curIndex = index;
      }
    });
    if(curIndex != -1){
      arr.splice(curIndex);
    }

  }


}

export default ArrayUtil
